export class CPPPriceListFilter {
  productName: string;
  accountNo: number;
  productNumber: string[];
  productLine: string[];
  packageSize: string[];
  productCategory: string[];
  supplier: string[];
  changedPrices: string[];
  changedTerms: string[];
  productBrand: string[];
  isGroup: boolean;
  changeSinceDate: any;
}
